import ClosableCard from "@/components/closable-card";
import { SignUpForm } from "@/components/signup-form";
import { CardContent } from "@/components/ui/card";

export default function Register() {
  return (
    <ClosableCard className="relative" title="Create your account">
      <CardContent>
        <SignUpForm />
      </CardContent>
    </ClosableCard>
  );
}
